import { useCallback } from 'react';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { setDismissedMaximiseTrialFeed } from 'actions';
import { useAppDispatch } from 'store/hooks';
import { tierGreaterThan, } from '../entities';
const useNavigateToPlanChangedScreen = (hasUsedFreeTrialBeforeRef) => {
    const navigation = useMainStackNavigation();
    const dispatch = useAppDispatch();
    const shouldShowWelcomeScreen = useCallback((newSku, previousSku) => {
        if (previousSku) {
            if (tierGreaterThan(newSku?.tier, previousSku?.tier)) {
                return () => {
                    navigation.navigate('PremiumSubscriptionWelcome', {
                        popCount: 1,
                        hasUsedFreeTrialBefore: hasUsedFreeTrialBeforeRef?.current,
                    });
                    dispatch(setDismissedMaximiseTrialFeed(true));
                };
            }
            return () => {
                if (navigation.canGoBack()) {
                    navigation.pop(1);
                }
            };
        }
        return undefined;
    }, [hasUsedFreeTrialBeforeRef]);
    const goToPlanChanged = useCallback((params) => {
        const welcomeScreenCb = shouldShowWelcomeScreen(params.newSku, params.previousSku);
        let callback = welcomeScreenCb;
        if (params.callback) {
            callback = () => {
                params.callback?.();
                welcomeScreenCb?.();
            };
        }
        navigation.navigate('ManagePremiumSubscriptionChanged', {
            ...params,
            callback,
        });
    }, [shouldShowWelcomeScreen]);
    const goToManagePlans = useCallback(() => {
        navigation.navigate('ManagePremiumSubscription', undefined, { pop: true });
    }, []);
    const onDiscount = useCallback((discount) => {
        goToManagePlans();
        goToPlanChanged({ discount, callback: () => { } });
    }, [goToManagePlans, goToPlanChanged]);
    const onPartialRefund = useCallback((discount, proratedRefund) => {
        goToManagePlans();
        goToPlanChanged({ discount, proratedRefund, callback: () => { } });
    }, [goToManagePlans, goToPlanChanged]);
    const onTrialExtended = useCallback((extensionDays) => {
        goToManagePlans();
        goToPlanChanged({
            trialExtension: { extensionDays },
            callback: () => { },
        });
    }, [goToManagePlans, goToPlanChanged]);
    return {
        onDiscount,
        onPartialRefund,
        onTrialExtended,
        goToPlanChanged,
    };
};
export default useNavigateToPlanChangedScreen;
